<script lang="ts">
  // UI components
  import * as Accordion from '$lib/components/ui/accordion/index.js';
  import { Label } from '$lib/components/ui/label/index.js';
  import { Switch } from '$lib/components/ui/switch/index.js';
  import * as Select from '$lib/components/ui/select/index.js';

  // Roastlog
  import { startStopShortcutEnabled, startStopShortcutKey } from '$lib/PersistedState.svelte';

  const validShortcuts = [
    { value: 'Space', label: 'Space' },
    { value: 'x', label: 'x' },
    { value: 'z', label: 'z' }
  ];

  const triggerContent = $derived(
    validShortcuts.find((f) => f.value === startStopShortcutKey.current)?.label ??
      'Select a shortcut'
  );
</script>

<Accordion.Item value="start-save-settings">
  <Accordion.Trigger>Save roast shortcut</Accordion.Trigger>
  <Accordion.Content>
    <div class="flex flex-row gap-x-5 px-2">
      <div class="w-1/2">
        <div class="flex flex-col gap-y-2">
          <Label for="startStopShortcutEnabled">Enable start/save roast shortcut</Label>
          <Switch name="startStopShortcutEnabled" bind:checked={startStopShortcutEnabled.current} />
        </div>
      </div>

      <div class="w-1/2 px-2 text-left">
        <Label for="startStopShortcutKey">Keyboard shortcut for start/save</Label>

        <Select.Root
          type="single"
          name="startStopShortcutKey"
          bind:value={startStopShortcutKey.current}
          disabled={!startStopShortcutEnabled.current}
        >
          <Select.Trigger class="mt-2 ml-2">
            {triggerContent}
          </Select.Trigger>
          <Select.Content>
            <Select.Group>
              {#each validShortcuts as shortcut (shortcut.value)}
                <Select.Item value={shortcut.value} label={shortcut.label}
                  >{shortcut.label}</Select.Item
                >
              {/each}
            </Select.Group>
          </Select.Content>
        </Select.Root>
      </div>
    </div>
    <div class="pt-2 text-xs">
      Enable this option to use a keyboard shortcut for starting and saving a roast. To enable this,
      toggle the switch and then select the key you'd like to use (spacebar is recommended).
    </div>
  </Accordion.Content>
</Accordion.Item>
